/**
 * Popup Banner Overlay - Side Panel
 * Handles open/close with storage to remember dismissal
 */
(function () {
  var STORAGE_KEY = 'popup-banner-overlay-dismissed';

  var panel = document.getElementById('popup-banner-overlay-panel');
  var closeBtn = document.getElementById('popup-banner-overlay-close');
  var tab = document.getElementById('popup-banner-overlay-tab');

  if (!panel || !tab) return;

  var autoOpen = panel.dataset.autoOpen === 'true';
  var delayMs = parseInt(panel.dataset.delay, 10) || 0;
  var storageMode = panel.dataset.storageMode || 'session';

  function isDismissed() {
    if (storageMode === 'none') return false;
    var storage = storageMode === 'local' ? localStorage : sessionStorage;
    return storage.getItem(STORAGE_KEY) === '1';
  }

  function setDismissed() {
    if (storageMode === 'none') return;
    var storage = storageMode === 'local' ? localStorage : sessionStorage;
    storage.setItem(STORAGE_KEY, '1');
  }

  function openPanel() {
    panel.classList.add('is-active');
    tab.classList.remove('is-visible');
  }

  function closePanel() {
    panel.classList.remove('is-active');
    tab.classList.add('is-visible');
    setDismissed();
  }

  closeBtn.addEventListener('click', closePanel);
  tab.addEventListener('click', openPanel);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && panel.classList.contains('is-active')) {
      closePanel();
    }
  });

  // Initial state
  if (isDismissed()) {
    tab.classList.add('is-visible');
  } else if (autoOpen) {
    setTimeout(openPanel, delayMs);
  } else {
    tab.classList.add('is-visible');
  }
})();
